const emailRegEx = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

export default emailRegEx;
